console.log("calc loaded!")

function calculate(min, max){
    const finalEl = document.getElementById('final');
    if (finalEl) finalEl.style.display = "none"; 
    
    let inputEl = document.getElementById('calculate-input');
    if (!inputEl) return;
    let m2 = inputEl.value;

    console.log(m2);

    let minM2 = (m2 / min).toFixed(2);
    let maxM2 = (m2 / max).toFixed(2);

    const finalTextEl = document.getElementById('final-text');
    if (finalTextEl) {
        let template = finalTextEl.getAttribute('data-result-template') || "Se estima que necesitarás entre [MIN] y [MAX] litros ([MIN_ML] y [MAX_ML] ml)";
        let txt = template
            .replace(/\[MIN\]/g, format(maxM2))
            .replace(/\[MAX\]/g, format(minM2))
            .replace(/\[MIN_ML\]/g, format(maxM2 * 1000))
            .replace(/\[MAX_ML\]/g, format(minM2 * 1000));
        
        finalTextEl.innerHTML = txt;
    }

    if (finalEl) finalEl.style.display = "inline-flex"; 
}

function format(x) {
    // x.toString().replace('.', ',');
    // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return x;
}

